import { useState } from 'react';
import styled from 'styled-components';
import { API_ROOT, sendRequest } from '../../../supplementary_components/requests';
import { addNotification } from '../../../supplementary_components/store';
import { retrieveCustomization, storeCustomizations } from '../../../supplementary_components/userDataDelegate';
import { MENU_LAYOUT_KEY } from '../../../general_components/main_menu/menuLayout';

const Box = styled.div`
    padding: 1.5rem;
    min-width: 22rem;
`;

const Title = styled.div`
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--extra-dark-gray);
    margin-bottom: 0.4rem;
`;

const Note = styled.p`
    margin: 0 0 1.2rem;
    color: var(--gray);
    font-size: var(--font-medium);
`;

const Choice = styled.button`
    display: block;
    width: 100%;
    margin-bottom: 0.6rem;
    padding: 0.8rem 1rem;
    border-radius: 10px;
    border: 1px solid ${props => props.$selected ? 'var(--main-color)' : 'var(--extra-light-gray)'};
    background: ${props => props.$selected ? 'rgba(48, 192, 140, 0.08)' : 'var(--bg)'};
    color: var(--dark-gray);
    text-align: left;
    cursor: pointer;
    font-weight: 600;

    span {
        display: block;
        margin-top: 0.2rem;
        font-weight: 500;
        color: var(--gray);
        font-size: 0.95rem;
    }
`;

export const MenuLayoutPopup = ({ closePopup }) => {
    const [layout, setLayout] = useState(() => (
        retrieveCustomization(MENU_LAYOUT_KEY) === 'classic' ? 'classic' : 'sidebar'
    ));
    const [saving, setSaving] = useState(false);

    const choose = (next) => {
        if (saving || next === layout) return;
        setSaving(true);
        sendRequest(
            'PATCH',
            API_ROOT + 'employees/customizations',
            null,
            (updated) => {
                storeCustomizations(updated);
                setLayout(next);
                setSaving(false);
                closePopup();
            },
            () => {
                setSaving(false);
                addNotification({ message: 'Could not save menu', type: 'alert' });
            },
            { [MENU_LAYOUT_KEY]: next },
        );
    };

    return (
        <Box>
            <Title>Menu</Title>
            <Note>Pinned shortcuts stay saved. They only appear in the sidebar.</Note>
            <Choice type="button" $selected={layout === 'sidebar'} onClick={() => choose('sidebar')}>
                Sidebar
                <span>The menu on the left, with shortcuts.</span>
            </Choice>
            <Choice type="button" $selected={layout === 'classic'} onClick={() => choose('classic')}>
                Top menu
                <span>The original menu across the top of the page.</span>
            </Choice>
        </Box>
    );
};
